import styled from 'styled-components'
import CreationToolSuperCutField from '../../../../../../types/super-cut-field'
import CaptionPositionField from '../../../../../form-fields/super-cut/caption-position'

const CaptionPosition = styled(CaptionPositionField)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureInfoCaptionPositionField = ({ field }: Props) => {
    return (
        <CaptionPosition
            {...{
                field,
            }}
        />
    )
}

export default CreationCaptureInfoCaptionPositionField
